export default "__VITE_ASSET__BWDf6UTJ__"